<ngx-loading-bar [height]="'4px'" [includeSpinner]="false"></ngx-loading-bar>
<div class="overlay" *ngIf="isOverlay"></div>
<router-outlet></router-outlet>